<template>
    <div class="auth-layout">
        <div class="auth-layout-container">
            <main :id="id">
                <router-view v-if="$store.getters['auth/isAuth'] === false" />
            </main>

            <the-footer class="footer-mobile" />
            <vue-snotify />
        </div>
    </div>
</template>

<script>
import TheFooter from '@/components/TheFooter'

export default {
    components: {
        TheFooter
    },

    props: {
        id: {
            type: String,
            default: 'app'
        }
    }
}
</script>
